// Patient billing and Revenue Console (MHIBackend Controllers/Billing)
export default {
    patientBilling: {
        getPermissions: {
            type: "get",
            showLoader: false,
            error: {
                default: "Unable to load billing permissions.",
            },
        },
        getSummary: {
            type: "get",
            error: {
                default: "Unable to load billing summary.",
            },
        },
        getServices: {
            type: "get",
            error: {
                default: "Unable to load billed services.",
            },
        },
        getServiceDetail: {
            type: "get",
            error: {
                default: "Unable to load service details.",
            },
        },
        getHistory: {
            type: "get",
            error: {
                default: "Unable to load billing history.",
            },
        },
        getNotes: {
            type: "get",
            showLoader: false,
            error: {
                default: "Unable to load billing notes.",
            },
        },
        getPaymentTypes: {
            type: "get",
            showLoader: false,
            error: {
                default: "Unable to load payment types.",
            },
        },
        getClaimPreview: {
            type: "get",
            error: {
                default: "Unable to build the claim.",
            },
        },
        getClaimLog: {
            type: "get",
            error: {
                default: "Unable to load the claim log.",
            },
        },
        postPatientPayment: {
            type: "post",
            error: {
                default: "Unable to record the payment.",
            },
        },
        postWriteOff: {
            type: "post",
            error: {
                default: "Unable to record the adjustment.",
            },
        },
        postInsurancePayment: {
            type: "post",
            error: {
                default: "Unable to post the insurance payment.",
            },
        },
        deletePatientPayment: {
            type: "delete",
            error: {
                default: "Unable to remove the payment.",
            },
        },
        submitClaim: {
            type: "post",
            error: {
                default: "Unable to send the claim.",
            },
        },
        checkClaimStatus: {
            type: "post",
            error: {
                default: "Unable to check the claim status.",
            },
        },
        addNote: {
            type: "post",
            error: {
                default: "Unable to save the note.",
            },
        },
    },
    revenue: {
        getRevenue: {
            type: "get",
            error: {
                default: "Unable to load revenue data.",
            },
        },
        submitClaims: {
            type: "post",
            error: {
                default: "Unable to send the claims.",
            },
        },
    },
};
